import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import IconButton from '@zenbusiness/zui/IconButton';
import InputBase from '@zenbusiness/zui/InputBase';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { PaperStyled } from './styles';

export default function SearchInput({
  value,
  placeholder,
  ariaLabel,
  width,
  maxWidth,
  withCancel,
  disabled = false,
  handleChange,
  handleClear,
  handleCancel,
  handleKeyPress,
  handleClick
}) {
  return (
    <Stack
      direction="row"
      height="100%"
      maxWidth={maxWidth}
      spacing="4px"
      width={width}
    >
      <PaperStyled
        disabled={disabled}
        sx={{ width, maxWidth }}
      >
        <Box
          alignItems="center"
          display="flex"
          height={{ sm: '36px', md: '40px' }}
          justifyContent="center"
          width={40}
        >
          <SharedAsset
            alt=""
            src="/icon/micro/search-grey.svg"
          />
        </Box>
        <InputBase
          disabled={disabled}
          inputProps={{ 'aria-label': ariaLabel }}
          onChange={handleChange}
          onClick={handleClick}
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          sx={{ ml: 0, flex: 1, mr: '8px' }}
          value={value}
        />
        {value && (
          <IconButton
            label="Clear search"
            onClick={handleClear}
            p="8px"
          >
            <SharedAsset
              alt=""
              src="/icon/micro/x-black.svg"
            />
          </IconButton>
        )}
      </PaperStyled>
      {withCancel && (
        <Button
          color="primary"
          onClick={handleCancel}
          variant="text"
        >
          Cancel
        </Button>
      )}
    </Stack>
  );
}

SearchInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  withCancel: PropTypes.bool,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  handleClear: PropTypes.func,
  handleCancel: PropTypes.func,
  handleKeyPress: PropTypes.func,
  handleClick: PropTypes.func
};
